import { useEffect, useMemo, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { fetchProtectedFile } from "../modules/utils/documentDownload";

const DocumentViewerPage = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const [error, setError] = useState("");
  const [blobUrl, setBlobUrl] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    const accessToken = params.get("_t") || localStorage.getItem("token");
    const streamUrl = params.get("_url");
    const nextFileName = params.get("_name") || "document.pdf";
    let objectUrl = "";

    setFileName(nextFileName);

    if (!accessToken || !streamUrl) {
      setError("ไม่พบลิงก์เอกสาร");
      return;
    }

    fetchProtectedFile({
      accessToken,
      streamUrl,
    })
      .then(blob => {
        objectUrl = window.URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        setError("เปิดเอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      });

    return () => {
      if (objectUrl) {
        window.URL.revokeObjectURL(objectUrl);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const handleOpenNewTab = () => {
    if (!blobUrl) return;
    window.open(blobUrl, "_blank", "noopener,noreferrer");
  };

  const handleDownload = () => {
    if (!blobUrl) return;

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        background: "#F5F7F8",
        fontFamily: "Google Sans, sans-serif",
      }}
    >
      {!blobUrl && !error ? (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "16px",
            padding: "24px",
          }}
        >
          <ProgressSpinner style={{ width: "56px", height: "56px" }} strokeWidth="4" />
          <div style={{ color: "#2C2C2C", fontSize: "16px", textAlign: "center" }}>
            กำลังเตรียมไฟล์ PDF...
          </div>
        </div>
      ) : null}

      {error ? (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "16px",
            padding: "24px",
            color: "#2C2C2C",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "16px" }}>{error}</div>
        </div>
      ) : null}

      {blobUrl ? (
        <>
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              display: "flex",
              gap: "12px",
              justifyContent: "center",
              padding: "12px",
              background: "#FFFFFF",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <button
              onClick={handleDownload}
              style={{
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                background: "#4263B5",
                color: "#FFFFFF",
                fontSize: "14px",
              }}
            >
              ดาวน์โหลด PDF
            </button>
            <button
              onClick={handleOpenNewTab}
              style={{
                border: "1px solid #4263B5",
                borderRadius: "8px",
                padding: "10px 16px",
                background: "#FFFFFF",
                color: "#4263B5",
                fontSize: "14px",
              }}
            >
              เปิดเต็มจอ
            </button>
          </div>
          <iframe
            src={blobUrl}
            title="PDF Viewer"
            style={{
              width: "100%",
              height: "calc(100vh - 64px)",
              border: "none",
            }}
          />
        </>
      ) : null}
    </div>
  );
};

export default DocumentViewerPage;
